import React from "react";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => {
  return {
    "@global": {
      "@keyframes ldio-jk70jumgjf-r": {
        "0%, 100%": {
          animationTimingFunction: "cubic-bezier(0.2 0 0.8 0.8)",
        },
        "50%": {
          animationTimingFunction: "cubic-bezier(0.2 0.2 0.8 1)",
          transform: "rotate(180deg)",
        },
        "0%": {
          transform: "rotate(0deg)",
        },
        "100%": {
          transform: "rotate(360deg)",
        },
      },
      "@keyframes ldio-jk70jumgjf-s": {
        "0%, 100%": {
          animationTimingFunction: "cubic-bezier(0.2 0 0.8 0.8)",
        },
        "50%": {
          animationTimingFunction: "cubic-bezier(0.2 0.2 0.8 1)",
          transform: "translate(-30px,-30px) scale(1)",
        },
        "0%": {
          transform: "translate(-30px,-30px) scale(0)",
        },
        "100%": {
          transform: "translate(-30px,-30px) scale(0)",
        },
      },
      ".ldio-jk70jumgjf > div": {
        transform: "translate(0px,-15px)",
      },
      ".ldio-jk70jumgjf > div > div": {
        animation: "ldio-jk70jumgjf-r 1s linear infinite",
        transformOrigin: "100px 100px",
      },
      ".ldio-jk70jumgjf > div > div > div": {
        position: "absolute",
        transform: "translate(100px, 82px)",
      },
      ".ldio-jk70jumgjf > div > div > div > div": {
        width: "60px",
        height: "60px",
        borderRadius: "50%",
        background: theme.palette.primary.main,
        animation: "ldio-jk70jumgjf-s 1s linear infinite",
      },
      ".ldio-jk70jumgjf > div > div:last-child": {
        animationDelay: "-0.5s",
      },
      ".ldio-jk70jumgjf > div > div:last-child > div > div": {
        animationDelay: "-0.5s",
        background: theme.palette.secondary.main,
      },
      ".loadingio-spinner-interwind-vcq7bcy426o": {
        width: "200px",
        height: "200px",
        display: "inline-block",
        overflow: "hidden",
        background: "#ffffff",
      },
      ".ldio-jk70jumgjf": {
        width: "100%",
        height: "100%",
        position: "relative",
        transform: "translateZ(0) scale(1)",
        backfaceVisibility: "hidden",
        transformOrigin: "0 0",
      },
      ".ldio-jk70jumgjf div": {
        boxSizing: "content-box",
      },
    },
    loaderContainer: {
      position: "absolute",
      left: 0,
      top: 0,
      width: "100%",
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "white",
    },
  };
});

export default () => {
  const classes = useStyles();

  return (
    <div className={classes.loaderContainer}>
      <div className="loadingio-spinner-interwind-vcq7bcy426o">
        <div className="ldio-jk70jumgjf">
          <div>
            <div>
              <div>
                <div></div>
              </div>
            </div>
            <div>
              <div>
                <div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
